import { axiosExternal } from '@/base/axios'

import { API } from '@/api/endpoints'

/**
 * Stats Token Utility
 * Manages the X-Stats-Token for tracking advertisement views
 */

const STATS_TOKEN_KEY = 'sais_stats_token'

/**
 * Get the stats token from localStorage
 */
export const getStatsToken = (): string | null => {
  if (typeof window === 'undefined') return null
  return localStorage.getItem(STATS_TOKEN_KEY)
}

/**
 * Save the stats token to localStorage
 */
export const setStatsToken = (token: string): void => {
  if (typeof window === 'undefined') return
  localStorage.setItem(STATS_TOKEN_KEY, token)
}

/**
 * Remove the stats token from localStorage
 */
export const removeStatsToken = (): void => {
  if (typeof window === 'undefined') return
  localStorage.removeItem(STATS_TOKEN_KEY)
}

/**
 * Initialize stats token on site access
 * Fetches a new token from the API if one doesn't exist in localStorage
 */
export const initStatsToken = async (): Promise<void> => {
  if (typeof window === 'undefined') return

  // Check if token already exists
  const existingToken = getStatsToken()
  if (existingToken) return

  try {
    // Fetch new token from API
    const response = await axiosExternal.get(API.STATS_TOKEN)

    // Get token from response header
    const token = response.headers['x-stats-token']

    if (token) setStatsToken(token)
  } catch (error) {
    console.error('Failed to initialize stats token:', error)
  }
}
